var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRun(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.19024 7.32488L6.66534 7.8799V10.8333H4.99868V6.70833H5.01119L9.40153 5.11039C9.60486 5.03212 9.82553 4.99302 10.0527 5.00067C10.9789 5.02344 11.7922 5.63057 12.0751 6.51697C12.2304 7.00359 12.372 7.33197 12.4999 7.50208C13.2602 8.51292 14.4698 9.16667 15.832 9.16667V10.8333C14.0198 10.8333 12.4006 10.0069 11.3307 8.7105L10.7494 12.0071L12.4987 13.475V19.1667H10.832V14.2521L8.94094 12.6653L8.33453 16.1044L2.58984 15.0915L2.87925 13.4501L6.98262 14.1737L8.19024 7.32488ZM11.2487 4.58333C10.3282 4.58333 9.58203 3.83714 9.58203 2.91667C9.58203 1.99619 10.3282 1.25 11.2487 1.25C12.1692 1.25 12.9154 1.99619 12.9154 2.91667C12.9154 3.83714 12.1692 4.58333 11.2487 4.58333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRun);
export default __webpack_public_path__ + "static/media/run.19a007418bfe37b8faea5e782bd8f84c.svg";
export { ForwardRef as ReactComponent };